/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

  // Clear button for the Form Search
  HTMLDocument.prototype.ready = function () {
    return new Promise(function(resolve, reject) {
      if (document.readyState === 'complete') {
        resolve(document);
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          resolve(document);
        });
      }
    });
  }
  
  document.ready().then(function(){
    var inputSearchFormSelector = jQ('.boost-pfs-search-input');
    var clearSearchFormSelector = jQ('.boost-pfs-search-form-btn-clear');

    if(!!inputSearchFormSelector.val()) {
      clearSearchFormSelector.show();
    }
    
    inputSearchFormSelector.on('change keydown keyup', function(){
      if(!!jQ(this).val()) {
        clearSearchFormSelector.show();
      } else {
        clearSearchFormSelector.hide();
      }
    })

    clearSearchFormSelector.on("click", function(){
      inputSearchFormSelector.val("");
      jQ(this).hide();
      inputSearchFormSelector.click();
    });
  })// End Clear button for the Form Search
  

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  // InstantSearchResultItemProduct.prototype.compileTemplate = function () {
  //   if (this.isShow) {
  //       var searchTerm = Utils.stripHtml(Globals.currentTerm);

  //       var variantSkuImage = this.data.variants.filter(variant => variant.sku == searchTerm);

  //       // Product image
  //       var imageHTML = '';
  //       if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
  //           imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
  //           if (variantSkuImage[0] && variantSkuImage[0].image) {
  //             imageHTML = imageHTML.replace(/{{imageUrl}}/g, variantSkuImage[0].image);
  //           } else {
  //             imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
  //           }
  //       }

  //       // Product title
  //       var productTitle = this.customizeProductTitle();
  //       productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
        
  //       // SKU
  //       var skuHTML = '';
  //       if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
  //           skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
  //           skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
  //       }

  //       // Vendor
  //       var vendorHTML = '';
  //       if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
  //           vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
  //           vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
  //       }
  //       // Price
  //       var priceHTML = this.compileSuggestionProductPrice();
  //       // Open the result item in new tab when selected
  //       var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
     
  //       // Found variant based on search term
  //       var itemUrl = this.url;

  //       if (this.data.hasOwnProperty('skus')) {
  //         var variantSKU = this.data.skus.filter(function(skuValue) {
  //           return skuValue.toLowerCase() == searchTerm.toLowerCase();
  //         })

  //         // Found variant ID based on the sku
  //         var variantID = this.data.variants.filter(function(varID) {
  //           if (varID.sku === variantSKU[0]) return varID.id;
  //         })
          
  //         if (typeof variantSKU[0] !== 'undefined' && typeof variantID[0] !== 'undefined') itemUrl += '?variant=' + variantID[0]['id'];
  //       }

  //       // Metafield
  //       var metafieldHTML = '';
     
  //       // Found variant based on search term
  //         console.log(this.data)
  //       var itemUrl = this.url;
  //       if (this.data.hasOwnProperty('metafields')) {
  //         var variantMetafield = this.data.metafields.filter(function(e) {
  //           return e.value.toLowerCase() == searchTerm.toLowerCase();
  //         })
  //         if (typeof variantMetafield[0] !== 'undefined') itemUrl += '?variant=' + variantMetafield[0]['id'];
  //       }

  //       return this.getTemplate()
  //           .replace(/{{id}}/g, this.id)
  //           .replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
  //           .replace(/{{url}}/g, itemUrl)
  //           .replace(/{{newTabAttribute}}/g, newTabAttr)
  //           .replace(/{{itemProductImage}}/g, imageHTML)
  //           .replace(/{{title}}/g, productTitle)
  //           .replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
  //           .replace(/{{itemProductSku}}/g, skuHTML)
  //           .replace(/{{itemProductVendor}}/g, vendorHTML)
  //           .replace(/{{itemProductPrice}}/, priceHTML)
  //           .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
  //           .replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
  //           .replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem)
  //   } else {
  //       return '';
  //   }
  // }

  // Start Boost 174762
  InstantSearchResultItemProduct.prototype.compileTemplate = function () {
    if (this.isShow) {
        var searchTerm = Utils.stripHtml(Globals.currentTerm);

        // if (searchTerm.includes('&#x2F;')) {
        //     searchTerm.replace('&#x2F;', '/');
        //     console.log(searchTerm)
        // }

        // Product image
        var imageHTML = "";
        if (
            Settings.getSettingValue("search.showSuggestionProductImage") &&
            this.imageUrl.length
        ) {
            imageHTML = this.getTemplate(
                InstantSearchResultItemProduct.tempType.IMAGE
            );
            imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
        }

        // Product title
        var productTitle = this.customizeProductTitle();
        productTitle = this._highlightSuggestionResult(
            productTitle,
            searchTerm
        );

        // Vendor
        var vendorHTML = "";
        if (Settings.getSettingValue("search.showSuggestionProductVendor") && this.vendor.length) {
            vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
            vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
        }
        // Price
        var priceHTML = this.compileSuggestionProductPrice();
        // Open the result item in new tab when selected
        var newTabAttr = Settings.getSettingValue("search.openProductNewTab") ? 'target="_blank"' : "";

        // SKU
        var skuHTML = "";
        if (Settings.getSettingValue("search.showSuggestionProductSku") && this.sku.length) {
            skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
            skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
        }
      
        // Found variant based on search term
        var itemUrl = this.url;

        if (this.data.hasOwnProperty("skus")) {
            var variantSKU = this.data.skus.filter(function (skuValue) {
                return skuValue.toLowerCase() == searchTerm.toLowerCase();
            });

            // Found variant ID based on the sku
            var variantID = this.data.variants.filter(function (varID) {
                if (varID.sku === variantSKU[0]) return varID.id;
            });

            if (typeof variantSKU[0] !== "undefined" && typeof variantID[0] !== "undefined") {
                // Change SKU 
                skuHTML = `<p class="boost-pfs-search-suggestion-product-sku">SKU: ${variantSKU[0]}</p>`;
                // Get variant ID url
                itemUrl += "?variant=" + variantID[0]["id"];
                // Change variant image
                // imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
                // imageHTML = imageHTML.replace(/{{imageUrl}}/g, variantID[0]["image"]);
            }
        }

        return this.getTemplate()
            .replace(/{{id}}/g, this.id)
            .replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
            .replace(/{{url}}/g, itemUrl)
            .replace(/{{newTabAttribute}}/g, newTabAttr)
            .replace(/{{itemProductImage}}/g, imageHTML)
            .replace(/{{title}}/g, productTitle)
            .replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
            .replace(/{{itemProductSku}}/g, skuHTML)
            .replace(/{{itemProductVendor}}/g, vendorHTML)
            .replace(/{{itemProductPrice}}/, priceHTML)
            .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
            .replace(
                /{{class.searchSuggestionItem}}/g,
                Class.searchSuggestionItem
            )
            .replace(
                /{{class.searchUiAutocompleteItem}}/g,
                Class.searchUiAutocompleteItem
            );
    } else {
        return "";
    }
  };
  
  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function () {
        this.prepareSuggestionProductPriceData();

        var searchTerm = Utils.stripHtml(Globals.currentTerm);

        // Check on sale
        var onSale = this.data.compare_at_price_min > this.data.price_min;
        // Format price
        var price = Utils.formatMoney(this.data.price_min);
        var compareAtPrice = "";
        if (this.data && this.data.compare_at_price_min) {
            compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
            if (Settings.getSettingValue("search.removePriceDecimal")) {
                price = Utils.removeDecimal(price);
                compareAtPrice = Utils.removeDecimal(compareAtPrice);
            }
        }

        if (this.data.hasOwnProperty("skus")) {
            var variantSKU = this.data.skus.filter(function (skuValue) {
                return (skuValue.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1);
            });
            // Found variant ID based on the sku
            if (typeof variantSKU[0] !== "undefined") {
                var variantID = this.data.variants.filter(function (varID) {
                    if (varID.sku === variantSKU[0]) return varID.id;
                });
console.log(variantID)
                if (typeof variantID[0] !== "undefined") {
                    onSale = variantID[0].compare_at_price > variantID[0].price;
                    // Format variant price
                    // var variant_regular_price = variantID[0].price.split(".")[0];
                    // price = Utils.formatMoney(variant_regular_price);
                    price = Utils.formatMoney(parseFloat(variantID[0].price));
                    console.log('price', variantID[0]);

                    var compareAtPrice = "";
                    if (variantID[0] && variantID[0].compare_at_price) {
                        var variant_sale_price = variantID[0].compare_at_price;
                        compareAtPrice = Utils.formatMoney(parseFloat(variant_sale_price));
                        // if (Settings.getSettingValue("search.removePriceDecimal")) {
                        //     price = Utils.removeDecimal(price);
                        //     compareAtPrice = Utils.removeDecimal(compareAtPrice);
                        // }
                          console.log('compareAtPrice', compareAtPrice);
                          console.log('price', price);
                    }
                }
            }
        }

        // Build Price
        var result = "";
        if (Settings.getSettingValue("search.showSuggestionProductPrice")) {
            if (onSale && Settings.getSettingValue("search.showSuggestionProductSalePrice")) {
                result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
            } else {
                result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
            }
        }

        // var priceVaries = this.data.price_min != this.data.price_max; // Check a product has many prices
        // if (priceVaries) {
        //     price = "From " + price;
        // }
        return result
            .replace(/{{regularPrice}}/g, price)
            .replace(/{{compareAtPrice}}/g, compareAtPrice);
    };
    // End Boost 174762

})();